import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-scrum-bread-bar",
  templateUrl: "./scrum-bread-bar.component.html",
  styleUrls: ["./scrum-bread-bar.component.scss"]
})
export class ScrumBreadBarComponent implements OnInit {
  pageName = "";
  parentIcon = "home";
  constructor() {}

  ngOnInit() {
    this.pageName = this.toProperCase(
      sessionStorage.getItem("pageName").toString()
    );
  }

  toProperCase(str) {
    return str.replace(/\w\S*/g, function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/scrum-bread-bar/scrum-bread-bar.component.ts